import axios from "axios";

const api = axios.create();

api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("accessToken");

    if (token && !config.skipAuth) {
      config.headers.Authorization = `Bearer ${atob(token)}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;